
    <h2>Sustainable Development Goals</h2>
    <p>Well-being and livelihood offerings can determine additional opportunities for customer interaction, funding sources, level of demand and more.</p>
    <h2>Sustainable Development Goals List</h2>
<ul> 
    <li>Goal 1: No poverty</li>
    <li>Goal 2: Zero Hunger</li>
    <li>Goal 3: Good Health and Well-Being</li>
    <li>Goal 4: Quality Education</li>
    <li>Goal 5: Gender Equality</li>
    <li>Goal 6: Clean Water and Sanitation</li>
    <li>Goal 7: Affordable Clean Energy</li>
    <li>Goal 8: Decent Work and Economic Growth</li>
    <li>Goal 9: Industry, Innovation and Infrastructure</li>
    <li>Goal 10: Reduced Inequalities</li>
    <li>Goal 11: Sustainable Cities and Communities</li>
    <li>Goal 12: Responsible Consumption and Production</li>
    <li>Goal 13: Climate Action</li>
    <li>Goal 14: Life Below Water</li>
    <li>Goal 15: Life on Land</li>
    <li>Goal 16: Peace, Justice and Strong Institutions</li>
    <li>Goal 17: Partnerships</li>
  </ul>  
<a href="https://www.un.org/sustainabledevelopment/sustainable-development-goals/" target="_blank">SDG Goals List Source </a>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Back</button>
</mat-dialog-actions>
